import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getContestWinnersData} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";

const CabinetContestWinners = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const laps = useSelector(store => store.cabinet.contestWinners);
    const winners = useSelector(store => store.cabinet.contestWinnersData);


    const [lapsDropStatus, setLapsDropStatus] = useState(false);
    const [activeLap, setActiveLap] = useState(laps ? laps[0].order : false);

    const lapsHandler = (order) =>{
        dispatch(getContestWinnersData(order));
        setActiveLap(order);
        setLapsDropStatus(false);
    }

    useEffect(() => {
        if (laps && laps.length > 0) {
            setActiveLap(laps[0].order);
        }
    }, [laps]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitleRow}`}>
                    <div className={`${Styles.contentWrapTitle}`}>{t('Победители')} <span>(TOP 20)</span></div>
                    <div className={`${Styles.contentWrapTitleRowFilter}`}>
                        <div
                            className={`${Styles.contentWrapTitleRowFilterText}`}
                            onClick={()=>{setLapsDropStatus(!lapsDropStatus)}}
                        >
                            {t('Круг')} #{activeLap ? activeLap : ''}
                            <span  className={`${lapsDropStatus ? Styles.active : null}`}>{'>'}</span>
                        </div>
                        <div className={`${Styles.contentWrapTitleRowFilterAbsDropdown} ${lapsDropStatus ? Styles.contentWrapTitleRowFilterAbsDropdownActive : null}`}>
                            {laps ? laps.map((item, index)=>{
                                return (
                                    <div
                                        className={`${Styles.contentWrapTitleRowFilterAbsDropdownItem} ${activeLap === item.order ? Styles.contentWrapTitleRowFilterAbsDropdownItemActive : null}`}
                                        key={'lapsDropdown' + index}
                                        onClick={()=>{
                                            lapsHandler(item.order)
                                        }}
                                    >
                                        {t('Круг')} #{item.order}
                                    </div>
                                )
                            }) : null}
                        </div>
                    </div>
                </div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.titleWrap}`}>
                        <div className={`${Styles.titleWrapItem}`}>{t('Никнейм')}</div>
                        <div className={`${Styles.titleWrapItem}`}>{t('Сумма выигрыша')}</div>
                    </div>
                    {
                        winners.length > 0 ?
                            <div className={`${Styles.tableWrap}`}>
                                {winners.map((item, index)=>{
                                    return (
                                        <div className={`${Styles.tableWrapRow}`} key={'winners' + index}>
                                            <div className={`${Styles.tableWrapRowItem}`}>{item.username}</div>
                                            <div className={`${Styles.tableWrapRowItem}`}>{item.tokens * 1} USDT</div>
                                        </div>
                                    )
                                })}
                            </div> :
                            <div className={`${Styles.tableWrapEmpty}`}>
                                <div className={`${Styles.tableWrapEmptyText}`}>{t('На данный момент, еще нет доступных данных')}.</div>
                            </div>
                    }
                </div>
            </div>
        </section>
    );
};

export default CabinetContestWinners;